import { api_url } from "../../../utils";

const Zeodh = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=zeodh_24&schema_city=",
    zindex: 2,
    type: "single",
    popup: {
        default: {
            content: {
                es: {
                    id_z24: "Número de la zona muestral (Z24): ",
                },
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.Zeodh",
    style: {
        regular: false,
        fillColor: "rgba(235, 228, 235, 0.7)",
        strokeColor: "rgba(205, 147, 205, 1)",
        strokeWidth: 2,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.Zeodh.title",
            subtitle: "",
            attribute: "",
            symbol: "rectangle",
            legendCustomCssClass:
                "map-legend-symbol-border-2-px-pink-205-147-205",
            class: [
                {
                    fillColor: "rgba(235, 228, 235, 0.7)",
                    strokeColor: "rgb(205, 147, 205)",
                    strokeWidth: 2,
                    label: "Mobility Indicators Content.layersLegend.Zeodh.classes.1",
                },
            ],
        },
    },
};

export default Zeodh;
